import { useEffect } from "react";

import iso from "i18n-iso-countries";
import { isEmpty } from "lodash";
import { Controller, useForm } from "react-hook-form";
import PhoneInput from "react-phone-input-2";

import { Button, Input, toastError, toastSuccess } from "@alpacahq/ui/old";

import { useMutationRequest } from "~/v2/api/hooks";
import { postTrustedAccount, type TrustedContact } from "~/v2/api/rest/account";
import { Field } from "~/v2/components/form";
import type { SettingsTabProps } from "../index";

export default ({ details, trusted_contact, account }: SettingsTabProps) => {
  const {
    control,
    handleSubmit,
    formState: { isDirty },
    reset,
  } = useForm<TrustedContact>({
    mode: "all",
  });

  const mutation = useMutationRequest((payload: Partial<TrustedContact>) =>
    postTrustedAccount(account.id, payload),
  );

  const onSubmit = (data: TrustedContact) => {
    mutation.mutate(data, {
      onSuccess: () => {
        // show a success toast
        toastSuccess("Trusted contact updated");
      },
      onError: (error) => {
        // show an error toast
        toastError(`Error updating trusted contact: ${error.message}`);
      },
    });
  };

  useEffect(() => {
    if (trusted_contact && !isEmpty(trusted_contact)) {
      reset({ ...trusted_contact });
    }
  }, [trusted_contact, reset]);

  return (
    <div className="w-full max-w-[600px]">
      <form onSubmit={handleSubmit(onSubmit)} id="ok">
        <div className="flex flex-col">
          <h2 className="mb-5 font-bold text-lg">Update Trusted Contact</h2>

          <Field label="First Name">
            <Controller
              name="given_name"
              control={control}
              rules={{ required: true }}
              render={({ field }) => <Input {...field} placeholder="Isaac" />}
            />
          </Field>

          <div className="mt-4">
            <Field label="Last Name">
              <Controller
                name="family_name"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <Input {...field} placeholder="Asimov" />
                )}
              />
            </Field>
          </div>
          <div className="mt-4">
            <Field label="Email">
              <Controller
                name="email_address"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <Input {...field} placeholder="isaac@example.com" />
                )}
              />
            </Field>
          </div>
          <div className="mt-4">
            <Field label="Phone Number">
              <Controller
                name="phone_number"
                control={control}
                rules={{ required: true }}
                render={({ field: { onChange, value } }) => (
                  <PhoneInput
                    inputStyle={{
                      width: "100%",
                      height: "40px",
                      background: "#e4e4e4",
                      border: "none",
                    }}
                    placeholder="+1 (123) 456-7890"
                    onChange={onChange}
                    value={value}
                    country={iso
                      .alpha3ToAlpha2(
                        // this is the only country we will have at first
                        details.country_of_tax_residence || "USA",
                      )
                      ?.toLowerCase()}
                  />
                )}
              />
            </Field>
          </div>
          <Button
            className="mt-8 mr-auto"
            disabled={!isDirty}
            type="submit"
            form="ok"
          >
            &nbsp;Save changes
          </Button>
        </div>
      </form>
    </div>
  );
};
